import Image from "next/image";
import type { FC } from "react";

export interface OptimizedImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  preload?: boolean;
  [key: string]: any;
}

export const OptimizedImage: FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className = "",
  preload = false,
  ...props
}) => {
  const baseSrc = src.replace(/\.\w+$/, "");

  return (
    <picture>
      <source srcSet={`${baseSrc}.webp`} type="image/webp" />
      <source srcSet={`${baseSrc}.png`} type="image/png" />
      <Image
        src={`${baseSrc}.webp`}
        alt={alt}
        width={width}
        height={height}
        loading={preload ? "eager" : "lazy"}
        placeholder="blur"
        blurDataURL="/images/placeholder.png"
        className={className}
        {...props}
      />
    </picture>
  );
};
